SCORM.dataElements = new Object();

SCORM.dataElements['cmi.core._children'] = 'RO';
SCORM.dataElements['cmi.interactions._children'] = 'RO';

SCORM.dataElements['cmi.core.student_id'] = 'RO';
SCORM.dataElements['cmi.learner_id'] = 'RO';

SCORM.dataElements['cmi.core.student_name'] = 'RO';
SCORM.dataElements['cmi.learner_name'] = 'RO';

SCORM.dataElements['cmi.core.lesson_location'] = 'RW';
SCORM.dataElements['cmi.location'] = 'RW';

SCORM.dataElements['cmi.core.lesson_mode'] = 'RO';
SCORM.dataElements['cmi.mode'] = 'RO';

SCORM.dataElements['cmi.core.credit'] = 'RO';
SCORM.dataElements['cmi.credit'] = 'RO';

SCORM.dataElements['cmi.core.lesson_status'] = 'RW';
SCORM.dataElements['cmi.completion_status'] = 'RW';
SCORM.dataElements['cmi.success_status'] = 'RW';

SCORM.dataElements['cmi.core.entry'] = 'RO';
SCORM.dataElements['cmi.entry'] = 'RO';

SCORM.dataElements['cmi.core.exit'] = 'WO';
SCORM.dataElements['cmi.exit'] = 'WO';

SCORM.dataElements['cmi.core.score._children'] = 'RO';
SCORM.dataElements['cmi.core.score.raw'] = 'RW';
SCORM.dataElements['cmi.core.score.max'] = 'RW';
SCORM.dataElements['cmi.core.score.min'] = 'RW';

SCORM.dataElements['cmi.score._children'] = 'RO';
SCORM.dataElements['cmi.score.scaled'] = 'RW';
SCORM.dataElements['cmi.score.raw'] = 'RW';
SCORM.dataElements['cmi.score.max'] = 'RW';
SCORM.dataElements['cmi.score.min'] = 'RW';

SCORM.dataElements['cmi.progress_measure'] = 'RW';

SCORM.dataElements['cmi.core.total_time'] = 'RO';
SCORM.dataElements['cmi.total_time'] = 'RO';

SCORM.dataElements['cmi.core.session_time'] = 'WO';
SCORM.dataElements['cmi.session_time'] = 'WO';

SCORM.dataElements['cmi.suspend_data'] = 'RW';
SCORM.dataElements['cmi.launch_data'] = 'RO';

SCORM.dataElements['cmi.comments'] = 'RW';
SCORM.dataElements['cmi.comments_from_lms'] = 'RO';

SCORM.dataElements['cmi.interactions._count'] = 'RO';

SCORM.dataElements['cmi.interactions.id'] = 'WO';
SCORM.dataElements['cmi.interactions.objectives._count'] = 'RO';
SCORM.dataElements['cmi.interactions.objectives.id'] = 'WO';
SCORM.dataElements['cmi.interactions.time'] = 'WO';
SCORM.dataElements['cmi.interactions.type'] = 'WO';
SCORM.dataElements['cmi.interactions.correct_responses'] = 'RO';
SCORM.dataElements['cmi.interactions.correct_responses_count'] = 'RO';
SCORM.dataElements['cmi.interactions.correct_responses.pattern'] = 'WO';
SCORM.dataElements['cmi.interactions.weighting'] = 'WO';
SCORM.dataElements['cmi.interactions.student_response'] = 'WO';
SCORM.dataElements['cmi.interactions.result'] = 'WO';
SCORM.dataElements['cmi.interactions.latency'] = 'WO';

// Data Elements Support Function
SCORM.isSupported = function (dataElementName) {
  // dataElementName.split('.')[4] <= _obj_count
  // flags
  let dataElementSupported = false;
  SCORM.dataElementRead = false;
  SCORM.dataElementWrite = false;

  if (dataElementName.indexOf('cmi.interactions') > -1) {
    dataElementName = dataElementName.replace(/\d+\./g, '');
  }

  // if the data element is in the list of supported elements
  if (dataElementName in SCORM.dataElements) {
    const rights = SCORM.dataElements[dataElementName];
    dataElementSupported = true;
    if (rights == 'RW' || rights == 'RO') {
      SCORM.dataElementRead = true;
    }
    if (rights == 'RW' || rights == 'WO') {
      SCORM.dataElementWrite = true;
    }
  }

  return dataElementSupported;
};

// SCORM.isReadable(dataElementName){

// }
